<template>
  <div>
    <hshead title="摄影师管理" waveBg="true"></hshead>
    <div class="tabs-box">
      <van-tabs v-model="tabactive" swipeable title-active-color="#007dfa" color="#007dfa">
        <van-tab title="摄影师名下">
          <div class="city-top" v-if="grapherAuditStatisticsData">
            <div class="top-left">
              <div class="this-p">已通过：{{grapherAuditStatisticsData.total_Pass}}</div>
              <div class="this-p">审核中：{{grapherAuditStatisticsData.total_Auditting}}</div>
            </div>
            <div class="top-right">
              <div class="this-img">
                <img src="~@/assets/images/city/p.png" alt />
              </div>
              <router-link to class="this-btn">共有摄影师</router-link>
            </div>
          </div>
          <div class="city-ul">
            <van-list v-model="loadingByGrapher" :finished="finishedByGrapher" finished-text="" @load="onLoadByGrapher">
              <div class="city-li" v-for="(item, index) in listByGrapher" :key="index">
                <div class="left-icon">
                  <img :src="item.headImageUrl" style="width:0.8rem" alt v-if="item.headImageUrl" />
                  <img src="~@/assets/images/city/p-b.png" style="width:0.8rem" alt v-else />
                </div>
                <div class="center-p">
                  <div class="center-h1">{{item.photoGrapherName}}</div>
                  <div class="center-time">{{item.createTime}}</div>
                </div>
                <div class="right-icon" v-if="item.auditStatus==2">
                  <img src="~@/assets/images/city/icon.png" alt='审核通过' />
                </div>
                <div class="right-icon" v-else-if="item.auditStatus==3">
                  <img src="~@/assets/images/city/icon-no.png" alt='审核不通过' />
                </div>
                <div class="right-btn-box" v-else>
                  <div class="right-btn primary" @click="auditGrapher(item, 2)">审核通过</div>
                  <div class="right-btn danger" @click="auditGrapher(item, 3)">审核不通过</div>
                </div>
              </div>
            </van-list>
            <div v-if="finishedByGrapher" class="emptyDataDiv_gray">
              <div v-if="listByGrapher.length==0">
                <van-icon name="info" />
                <p>没有摄影师</p>
              </div>
              <!-- <div v-else>没有更多了</div> -->
            </div>
          </div>
        </van-tab>
        <van-tab title="约拍城市审核" v-if="isQuPaiPaiSelfStore">
          <div class="city-top" v-if="shootCitysAuditStatisticsData">
            <div class="top-left">
              <div class="this-p">已通过：{{shootCitysAuditStatisticsData.total_Pass}}</div>
              <div class="this-p">审核中：{{shootCitysAuditStatisticsData.total_Auditting}}</div>
            </div>
            <div class="top-right">
              <div class="this-img">
                <img src="~@/assets/images/city/city.png" alt />
              </div>
              <router-link to class="this-btn">已有城市</router-link>
            </div>
          </div>
          <div class="city-ul">
            <van-list v-model="loadingByShootCitys" :finished="finishedByShootCitys" finished-text="" @load="onLoadByShootCitys">
              <div class="city-li" v-for="(item, index) in listByShootCitys" :key="index">
                <div class="left-icon">
                  <img src="~@/assets/images/city/tempCity.png" alt />
                </div>
                <div class="center-p">
                  <div class="center-h1">{{item.photoGrapherName}}</div>
                  <div class="center-h1" v-if="item.provinceId=='*'&&item.cityId=='*'">中国</div>
                  <div class="center-h1" v-else>{{item.provinceName}} {{item.cityName}}</div>
                  <div class="center-time">{{item.createTime}}</div>
                </div>
                <div class="right-icon" v-if="item.status==2">
                  <img src="~@/assets/images/city/icon.png" alt='审核通过' />
                </div>
                <div class="right-icon" v-else-if="item.status==3">
                  <img src="~@/assets/images/city/icon-no.png" alt='审核不通过' />
                </div>
                <div class="right-btn-box" v-else>
                  <div class="right-btn primary" @click="auditShootCity(item, 2)">审核通过</div>
                  <div class="right-btn danger" @click="auditShootCity(item, 3)">审核不通过</div>
                </div>
              </div>
            </van-list>
            <div v-if="finishedByShootCitys" class="emptyDataDiv_gray">
              <div v-if="listByShootCitys.length==0">
                <van-icon name="info" />
                <p>没有要审核的数据</p>
              </div>
              <!-- <div v-else>没有更多了</div> -->
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
   <van-tabbar v-model="active">
      <van-tabbar-item to="MissionHall">
        <span>任务中心</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_taskCenter.active : icon_taskCenter.inactive
            "
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="Income" icon="chart-trending-o">
        <span>收益</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_earnings.active : icon_earnings.inactive
            "
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="Grapher" icon="manager-o">
        <span>摄影师</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_cameraman.active : icon_cameraman.inactive
            "
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="Product" icon="orders-o">
        <span>商品管理</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_product.active : icon_product.inactive
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Other" icon="apps-o">
        <span>更多</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_more.active : icon_more.inactive
            "
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>

import hshead from "@/components/common/hshead";
import { Toast, Tab, Tabs, List, Tabbar, TabbarItem, Dialog, Icon } from "vant";
import { getGrapherPager, getPhotoGrapherAuditStatistics, auditGrapher, getStoreExtInfo } from "@/api/m/store";
import { getPagerByStore as getShootCityPager, getAuditCityStatisticsByStore, auditShootCity } from "@/api/m/shootCity";
// 任务中心
import taskCenter_icon from "@/assets/images/center/nav-1.png";
import taskCenter_icon_act from "@/assets/images/center/nav-1-act.png";
//收益
import earnings_icon from "@/assets/images/center/nav-2.png";
import earnings_icon_act from "@/assets/images/center/nav-2-act.png";
//摄影师
import cameraman_icon from "@/assets/images/center/nav-3.png";
import cameraman_icon_act from "@/assets/images/center/nav-3-act.png";
//商品管理
import product_icon from "@/assets/images/center/nav-4.png";
import product_icon_act from "@/assets/images/center/nav-4-act.png";
//更多
import more_icon from "@/assets/images/center/nav-5.png";
import more_icon_act from "@/assets/images/center/nav-5-act.png";


export default {
  name: "photographer",
  data() {
    return {
      tabactive: 0,
      active: 2,
      //摄影师
      grapherAuditStatisticsData:  null,
      listByGrapher: [],
      loadingByGrapher: false,
      finishedByGrapher: false,
      listQueryByGrapher: {
        pn: 1,
        ps: 20,
      },
      //约拍城市
      shootCitysAuditStatisticsData:  null,
      listByShootCitys: [],
      loadingByShootCitys: false,
      finishedByShootCitys: false,
      listQueryByShootCitys: {
        pn: 1,
        ps: 20,
      },
      //是否为去拍拍自营店
      isQuPaiPaiSelfStore: false,
      icon_taskCenter: {
        active: taskCenter_icon_act,
        inactive: taskCenter_icon,
      },
      icon_earnings: {
        active: earnings_icon_act,
        inactive: earnings_icon,
      },
      icon_cameraman: {
        active: cameraman_icon_act,
        inactive: cameraman_icon,
      },
      icon_product: {
        active: product_icon_act,
        inactive: product_icon,
      },
      icon_more: {
        active: more_icon_act,
        inactive: more_icon,
      },
    };
  },
  created() {
    //获取摄影师统计信息
    this.getPhotoGrapherAuditStatistics()
    //获取登录用户的店铺信息
    this.getStoreExtInfo()
    // //获取约拍城市统计信息
    // this.getAuditCityStatisticsByStore()
  },
  methods: {
    onLoadByShootCitys() {
      this.getShootCityPager();
    },
    onLoadByGrapher() {
      this.getGrapherPager();
    },
    //获取摄影师统计信息
    getPhotoGrapherAuditStatistics() {
      this.load(true, '加载中...');
      getPhotoGrapherAuditStatistics().then(response => {
        this.load(false);
        const { code, msg, data } = response;
        if (code >= 0) {
          this.grapherAuditStatisticsData = data
        }
      }).catch(response => {
        this.load(false);
        //this.tips(`${response.msg}`);
        Toast.fail({duration:1000 * 5, message: `${response.msg}`});
      });
    },
    //摄影师列表数据
    getGrapherPager() {
      getGrapherPager(this.listQueryByGrapher).then(response => {
        console.info('response', response)
        const { code, msg, data } = response;
        if (code >= 0) {
          console.info('getGrapherPager -> data', data)
          this.listQueryByGrapher.pn = this.listQueryByGrapher.pn + 1
          //
          if(data.totalRecord == 0){
            this.loadingByGrapher = false;
            this.finishedByGrapher = true;
          }
          else {
            data.list.map(item => {
              this.listByGrapher.push(item)
            })
            // 加载状态结束
            this.loadingByGrapher = false;
            // 数据全部加载完成
            if (this.listByGrapher.length >= data.totalRecord) {
              this.finishedByGrapher = true;
            }
          }
        }
      })
      .catch(response => {
        //this.tips(`${response.msg}`);
        Toast.fail({duration:1000 * 5, message: `${response.msg}`});
      });
    },
    // 摄影师审核
    auditGrapher(row, status) {
      Dialog.confirm({
        title: '提示',
        message: `确认摄影师${status==2?'【审核通过】':'【审核不通过】'}`
      }).then(() => {
        this.load(true, '加载中...');
        const param = {
          Id: row.id,
          AuditStatus: status,
        }
        auditGrapher(param).then(response => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.tips(`操作成功`);
            row.auditStatus = status
          }
        }).catch(response => {
          this.load(false);
          //this.tips(response.msg);
          Toast.fail({duration:1000 * 5, message: `${response.msg}`});
        });
      }).catch(() => {
        // on cancel
      });
    },
    
    //获取登录用户的店铺信息
    getStoreExtInfo() {
      getStoreExtInfo(this.listQueryByGrapher).then(response => {
        console.info('response', response)
        const { code, msg, data } = response;
        if (code >= 0) {
          console.info('getStoreExtInfo -> data', data)
          this.isQuPaiPaiSelfStore = data.isQuPaiPaiSelfStore
          if(data.isQuPaiPaiSelfStore) {
            //获取约拍城市统计信息
            this.getAuditCityStatisticsByStore()
          }
        }
      })
      .catch(response => {
        //this.tips(`${response.msg}`);
        Toast.fail({duration:1000 * 5, message: `${response.msg}`});
      });
    },

    //获取约拍城市统计信息
    getAuditCityStatisticsByStore() {
      this.load(true, '加载中...');
      getAuditCityStatisticsByStore().then(response => {
        this.load(false);
        const { code, msg, data } = response;
        if (code >= 0) {
          this.shootCitysAuditStatisticsData = data
        }
      }).catch(response => {
        this.load(false);
        //this.tips(`${response.msg}`);
        Toast.fail({duration:1000 * 5, message: `${response.msg}`});
      });
    },
    //约拍城市列表数据
    getShootCityPager() {
      getShootCityPager(this.listQueryByShootCitys).then(response => {
        console.info('response', response)
        const { code, msg, data } = response;
        if (code >= 0) {
          console.info('getShootCityPager -> data', data)
          this.listQueryByShootCitys.pn = this.listQueryByShootCitys.pn + 1
          //
          if(data.totalRecord == 0){
            this.loadingByShootCitys = false;
            this.finishedByShootCitys = true;
          }
          else {
            data.list.map(item => {
              this.listByShootCitys.push(item)
            })
            // 加载状态结束
            this.loadingByShootCitys = false;
            // 数据全部加载完成
            if (this.listByShootCitys.length >= data.totalRecord) {
              this.finishedByShootCitys = true;
            }
          }
        }
      })
      .catch(response => {
        //this.tips(`${response.msg}`);
        Toast.fail({duration:1000 * 5, message: `${response.msg}`});
      });
    },
    // 约拍城市审核
    auditShootCity(row, status) {
      Dialog.confirm({
        title: '提示',
        message: `确认约拍城市${status==2?'【审核通过】':'【审核不通过】'}`
      }).then(() => {
        this.load(true, '加载中...');
        const param = {
          Ids: [row.id],
          status,
        }
        auditShootCity(param).then(response => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.tips(`操作成功`);
            row.status = status
          }
        }).catch(response => {
          this.load(false);
          //this.tips(response.msg);
          Toast.fail({duration:1000 * 5, message: `${response.msg}`});
        });
      }).catch(() => {
        // on cancel
      });
    },
  },
  components: {
    hshead,
    "van-list": List,
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem,
    [Dialog.Component.name]: Dialog.Component,
    "van-icon": Icon
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
@import "~@/assets/less/mixin.less";
.tabs-box {
  margin-top: -4.3rem;
}
.city-top {
  display: flex;
  margin-top: 0.3rem;
  .top-left {
    width: 3.41rem;
    height: 1.04rem;
    border-right: 1px solid rgba(255, 255, 255, 0.6);
    .this-p {
      font-family: PingFang-SC-Medium;
      font-size: 0.3rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0rem;
      color: #ffffff;
      padding-left: 1rem;
      padding-top: 0.15rem;
    }
  }
  .top-right {
    flex: 1;
    display: flex;
    .this-img {
      width: 1.9rem;
      text-align: center;
      img {
        width: 0.83rem;
        height: 0.87rem;
        display: inline-block;
      }
    }
    .this-btn {
      display: block;
      text-align: center;
      margin-top: 0.3rem;
      width: 1.65rem;
      height: 0.51rem;
      border-radius: 0.06rem;
      font-family: PingFang-SC-Medium;
      font-size: 0.24rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0.51rem;
      letter-spacing: 0rem;
      color: #fff;
      background: none !important
    }
  }
}
.city-ul {
  margin-top: 0.9rem;
  margin-bottom: 1rem;
  .city-li {
    width: 6.7rem;
    height: 2.01rem;
    background-color: #fff;
    box-shadow: 0rem 1px 0.18rem 0rem rgba(129, 135, 148, 0.18);
    border-radius: 0.06rem;
    display: flex;
    margin: 0 auto;
    margin-bottom: 0.35rem;
    .left-icon {
      width: 2.08rem;
      text-align: center;
      padding-top: 0.4rem;
      img {
        width: 1.17rem;
        height: auto;
        display: inline-block;
      }
    }
    .center-p {
      width: 3.48rem;
      padding-top: 0.4rem;
      .center-h1 {
        font-family: PingFang-SC-Medium;
        font-size: 0.28rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #333333;
        padding-bottom: 0.35rem;
      }
      .center-time {
        font-family: PingFang-SC-Medium;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #808d9e;
      }
    }

    .right-icon {
      width: 0.9rem;
      padding-top: 0.14rem;
      img {
        width: 0.9rem;
      }
    }
    .right-btn-box {
      margin-top: 0.4rem;
      .right-btn {
        width: 1.7rem;
        height: 0.5rem;
        line-height: 0.5rem;
        text-align: center;
        color: #fff;
        background: #000;
        font-size: 0.24rem;
        margin-bottom: 0.2rem;
        margin-right: 0.1rem;
        border-radius: 0.2rem;
        &.primary {
          background: #07c160;
        }
        &.danger {
          background: #f44;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/store/grapher.vue